import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Component({
  selector: 'va-cta-dialog',
  templateUrl: './get-pro-dialog.component.html',
  styleUrls: ['./get-pro-dialog.component.scss'],
  standalone: false,
})
export class UpgradeCTADialogComponent {
  public isLoading = false;
  public hasActiveOrder = false;

  sanitizedSellingPoints: string[];
  selectedAddonId: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<UpgradeCTADialogComponent, UpgradeCTADialogResult>,
    @Inject(MAT_DIALOG_DATA) public config: UpgradeCTADialogConfig,

    private sanitizer: DomSanitizer,
  ) {
    this.sanitizedSellingPoints =
      this.config.keySellingPoints?.map((sellingPoint) => this.sanitizeSellingPoint(sellingPoint)) ?? [];
    this.selectedAddonId = this.config.defaultAddonId;
  }

  sanitizeSellingPoint(sellingPoint: string): string {
    return DOMPurify.sanitize(sellingPoint);
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true, selectedAddonId: this.selectedAddonId });
  }

  onDismiss(): void {
    this.dialogRef.close({ confirmed: false });
  }
}

export interface UpgradeCTADialogConfig {
  imageText?: string;
  imageUrl?: string;
  editionName?: string;
  upgradeNowText?: string;
  price?: string;
  frequency?: string;
  keySellingPoints?: string[];
  templateSellingPoints?: TemplateSellingPoint[];
  ctaText?: string;
  activeOrderPrimaryText?: string;
  activeOrderSecondaryText?: string;
  activeOrderImageUrl?: string;
  addons?: UpgradeCTADialogAddon[];
  addonsLabel?: string;
  addonPlaceholder?: string;
  defaultAddonId?: string;
}

export interface TemplateSellingPoint {
  text: string;
  template: object;
}

export interface UpgradeCTADialogAddon {
  readonly id: string;
  readonly label: string;
}

export interface UpgradeCTADialogResult {
  readonly confirmed: boolean;
  readonly selectedAddonId?: string;
}
